import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import Page from 'components/Page/Dashboard';
import AdditionalInfo from 'components/Play/Tournament/Edit/AdditionalInfo';

const Step5 = ({ match }) => (
  <Page showNavigation={false}>
    <AdditionalInfo edit={match.path.includes('edit')} />
  </Page>
);

Step5.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(Step5);
